import objectUtils from '../utils/object-utils'

export default class OrgRegistrationCode {
  constructor (options = {}) {
    this.model = 'OrgRegistrationCode'

    this.id = objectUtils.get(options, 'id', null)
    this.email = objectUtils.get(options, 'email', null) // the owner email
    this.org_type_code = objectUtils.get(options, 'org_type_code', null)
    this.org_id = objectUtils.get(options, 'org_id', null)
    this.registration_code = objectUtils.get(options, 'registration_code', null)

    // Status
    this.status = objectUtils.get(options, 'status', null)
    this.expires_at = objectUtils.get(options, 'expires_at', null)

    // Auditing
    this.created_by = objectUtils.get(options, 'created_by', null)
    this.accepted_at = objectUtils.get(options, 'accepted_at', null)
    this.canceled_at = objectUtils.get(options, 'canceled_at', null)
    this.canceled_by = objectUtils.get(options, 'canceled_by', null)
    this.created_at = objectUtils.get(options, 'created_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)

    // Associations
    if (options.org) this.org = options.org
    if (options.creator) this.creator = options.creator
    if (options.owner) this.owner = options.owner
  }
}
